module.exports = __webpack_public_path__ + "img/179976.2b226a6f.png";